import { useNavigate } from 'react-router-dom';

import ClaimLookup from '@/components/ClaimLookup';
import PageHeader from '@/components/PageHeader';
import useNavigateToPage from '@/hooks/useNavigateToPage';
import Button from '@/ui/components/Button';
import Card from '@/ui/components/Card';
import Container from '@/ui/components/Container';

function BillingDashboard() {
  const { navigateToNewRemit, navigateToRemits } = useNavigateToPage();
  const navigate = useNavigate();

  const handleBillingReportClick = () => {
    navigate('/billing/reports');
  };

  const handleBillingItemsClick = () => {
    navigate('/billing/items');
  };

  return (
    <Container type="page">
      <Card>
        <div>
          <PageHeader value={1} headingText={'Billing Dashboard'} />
          <ClaimLookup />

          {/* The billing rail carries these on desktop; below `lg` there is no rail. */}
          <div className="mt-3 gap-3 flex lg:hidden">
            <Button color="green" onClick={() => navigateToNewRemit()}>
              Add a Remit
            </Button>
            <Button onClick={() => navigateToRemits()}>View Remits</Button>
            <Button color="blue" onClick={handleBillingReportClick}>
              Billing Reports
            </Button>
            <Button color="blue" onClick={handleBillingItemsClick}>
              Billing Items
            </Button>
          </div>
        </div>
      </Card>
    </Container>
  );
}

export default BillingDashboard;
